module.exports = __webpack_public_path__ + "static/media/sunset.db779653.svg";